export class DriftProtectionSummary {
    'data';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<DriftProtectionTimePoint>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DriftProtectionSummary.attributeTypeMap;
    }
    constructor() {
    }
}
